import { State } from './types'

export const initialState: State = {
  propertyLoaderStatus: {
    loading: true,
    error: false,
    waitingAnimation: true,
  },
  firtsTime: true,
  properties: [],
  page: {
    currentPage: 0,
    perpage: 0,
    totalItems: 0,
    totalPages: 0,
    globalCount: undefined,
  },

  hoveredPropertyCard: undefined,
}
